import { render, staticRenderFns } from "./PropertyInput.vue?vue&type=template&id=6738c2a2&"
import script from "./PropertyInput.vue?vue&type=script&lang=js&"
export * from "./PropertyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports